import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChevronDown} from "@fortawesome/pro-light-svg-icons/faChevronDown";
import {faChevronUp} from "@fortawesome/pro-light-svg-icons/faChevronUp";

const MobileDropdownItem = ({title, subtitle, activeClass, toggleSubmenu, open }) =>
    (
        <div className={"menu-item d-block d-sm-block d-lg-none " + activeClass} onClick={toggleSubmenu}>
            {title} {open ? <FontAwesomeIcon icon={faChevronUp} className="float-right pt-1"/> : <FontAwesomeIcon icon={faChevronDown} className="float-right pt-1"/> }
            <span className="d-none d-md-block small">{subtitle}</span>
        </div>
    );

const DesktopDropdownItem = ({title, subtitle, activeClass, toggleSubmenu}) =>
    (
        <div className={"menu-item d-none d-md-none d-lg-block " + activeClass} onClick={toggleSubmenu}  >
            {title}
            <span className="d-none d-md-block small">{subtitle}</span>
        </div>
    );

export { MobileDropdownItem, DesktopDropdownItem };
